import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES,useParams } from './../../common/helper/common-imports.component.js';
import ConfigService from "../../../services/config-service.js";
import DistributorsService from "../../../services/distributors-service.js";
import {initialErrors, fieldValidation  } from '../../common/helper/form-constants.js';
import ConfigurationService from "../../../services/configuration-service";
import { FormField, SelectField } from './../../common/helper/formFields';

const EditDistributor = () => { 
    const [merchant, setMerchant] = useState({});
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('per_details');
    const [formData, setFormData] = useState({ });
    const [errors, setErrors] = useState({ ...initialErrors });
    const [formDataPersonal, setFormDataPersonal] = useState({ });
    const [statesData,setStatesData] = useState([]);
    const [businessTypes,setbusinessTypes] = useState([]);
    const [industryTypes,setindustryTypes] = useState([]);
    const [formDataBusiness,setFormDataBusiness] = useState({})
    const [formDataUsers,setFormDataUsers] = useState({})
    const [city,setCity] = useState([]);
    const [users,setUsers] =  useState([]);
    const [limitGroups,setlimitGroups] = useState([]);
    const { id } = useParams();
    const navigate = useNavigate();
    const [commGroup, setCommGroup] = useState([]);


    const fetchData = async () => {
        try {
          setLoading(true);
          const [statesResponse, businessTypeResponse, industriesResponse, limitGroup, commResponse] = await Promise.all([
            ConfigService.getStates(),
            ConfigService.getBusinessType(),
            ConfigService.getIndustries(),
            ConfigurationService.getAgentLimitList(),
            ConfigService.getCommGroups('MERCHANT'),


          ]);
          const states =  statesResponse.data.data.map(state => ({ value: state.id, label: state.state }));
          const business = Object.entries(businessTypeResponse.data.data).map(([key, value]) => ({
            value: key,
            label: value
          }));
          const industries = Object.entries(industriesResponse.data.data).map(([key, value]) => ({
            value: key,
            label: value
          }));
          const limitGroups = Object.entries(limitGroup.data.data).map(([key, value]) => ({
            value: value.limit_group_id,
            label: value.limit_group_name
          }));
          const comm =   commResponse.data.data.map(record => ({ value: record.key, label: record.value }));
      setCommGroup(comm);
          setStatesData(states)
          setbusinessTypes(business)
          setindustryTypes(industries)
          getMerchant();
          setlimitGroups(limitGroups)
          setLoading(false);
        } catch (error) {
          setLoading(false);

        }
      };
      const getUsers = (id, data) => {
        setLoading(true);
        DistributorsService.getDistributorUsers(id)
          .then(response => {
            const users =  response.data.data.map(user => ({ value: user.key, label: user.value }));
            setUsers(users)
            setAdminUserInfo(data)
          })
          .catch(error => {
           
            setLoading(false);
          });
      }
      const getCities = (stateID, data=null) => {
        setLoading(true);
        ConfigService.getCities(stateID)
          .then(response => {
            const cities =  response.data.data.map(city => ({ value: city.id, label: city.city }));
            setCity(cities)
            setAddressInfo(data);
            setLoading(false);
          })
          .catch(error => {

            setLoading(false);

          });
      }

    const getMerchant = () => {
        setLoading(true);
        DistributorsService.getDistributorDetails(id)
              .then(response => {
                const data =response.data.data
                setMerchant(data)
                setPersonalInfo(data);
                getCities(data.address_detail.state_id, data)
              
                getUsers(data.merchant_detail.merchant_id, data)
                setBusinessInfo(data);
                setLoading(false);
              })
              .catch(error => {
                setLoading(false);
                const errorMessage = error.response.data
                toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
              });
      }
    
      const updateMerchantInfo = (id,data) => {
        setLoading(true);
        DistributorsService.updateDistributor(id,data)
          .then(response => {
            setLoading(false);
            navigate('/distributors')
            toast.success(MESSAGES.DIST_UPDATED)
          })
          .catch(error => {
            try{
                const errorMessage = error.response.data
                toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
            } catch (e) {
                toast.error( MESSAGES.SERVER_ERROR)
            }
            setLoading(false);
          });
      }

      const setPersonalInfo = (merchant) => {
        
        const personalInfo = {
            fullName: merchant.merchant_detail.merchant_name,
            email: merchant.merchant_detail.email_address,
            transaction_type: merchant.merchant_detail.business_type_id,
            phoneNumber: merchant.merchant_detail.phone_number,
           // limit_group_id: merchant.merchant_detail.limit_group_id,
            comm_grp_id: merchant.merchant_detail.commision_group
        }
        setFormData(personalInfo);
      }
      const setAddressInfo = (merchant) => {
        const addressInfo = {
            addressLine1: merchant.address_detail.address1,
            addressLine2: merchant.address_detail.address2,
            city: merchant.address_detail.city_id,
            state: merchant.address_detail.state_id,
            postalCode: merchant.address_detail.zip
        }
        setFormDataPersonal(addressInfo);
      }

      const setBusinessInfo = (merchant) => {
        const businessInfo = {
            registrationNumber: merchant.business_detail.business_registration_number,
            industry: merchant.business_detail.industry_type_id,
            description: merchant.business_detail.description,
        }
        setFormDataBusiness(businessInfo);
      }

      const setAdminUserInfo  = (merchant) => {

        const adminUser = {
            user: merchant.admin_detail.user_id
        }
        setFormDataUsers(adminUser);
      }

    

      const updatePersonal = (e) => {
        e.preventDefault();
        let hasErrors = false;
        let requiredFields =['fullName', 'email', 'phoneNumber', 'transaction_type','comm_grp_id'];
        requiredFields.forEach(fieldName => {
          const error = validateField(fieldName, formData[fieldName]);
          if (error) {
            hasErrors = true;
          }
        });

        if(!hasErrors){
            const dataToupdate = {
                merchant_detail:{
                    merchant_name: formData.fullName,
                    email_address: formData.email,
                    phone_number:formData.phoneNumber,
                    business_type_id: formData.transaction_type,
                    limit_group_id: formData.limit_group,
                    commision_group: formData.comm_grp_id
                }
            }
            updateMerchantInfo(id,dataToupdate)
        }
      }
      const updateAddress = (e) => {
        e.preventDefault();
        let hasErrors = false;
        let requiredFields =['addressLine1', 'city', 'state', 'postalCode'];
        requiredFields.forEach(fieldName => {
          const error = validateField(fieldName, formDataPersonal[fieldName]);
          if (error) {
            hasErrors = true;
          }
        });
        if(!hasErrors){

            const dataToupdate = {
                address_detail:{
                    address1: formDataPersonal.addressLine1,
                    address2: formDataPersonal.addressLine2,
                    city_id:formDataPersonal.city,
                    state_id: formDataPersonal.state,
                    zip: formDataPersonal.postalCode,
                }
            }
            updateMerchantInfo(id,dataToupdate)
        }
      }
      const updateBusiness = (e) => {
        e.preventDefault();
        const dataToupdate = {
            business_detail:{
                business_registration_number: formDataBusiness.registrationNumber,
                industry_type_id: formDataBusiness.industry,
                description:formDataBusiness.description,
            }
        }
        updateMerchantInfo(id,dataToupdate)
      }
      const updateAdmin = (e) => {
        e.preventDefault();
        const hasErrors =  Object.values(formDataUsers).some(value => value === '');
        if(!hasErrors){
          const dataToupdate = {
              admin_detail:{
                  user_id: formDataUsers.user,
              }
          }
          updateMerchantInfo(id,dataToupdate)
        }
       
      }
      const validateField = (fieldName, value) => {
        const errorMessage = fieldValidation(fieldName, value);
        setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
        return errorMessage
      };
      const handleChangeUser  = (e) => {
        const { name, value } = e.target;
        setFormDataUsers((prevData) => ({ ...prevData, [name]: value }));
        validateField(name, value);
      }
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
        validateField(name, value);
      }
      const handleChangeAddress = (e) => {
        const { name, value } = e.target;
        setFormDataPersonal((prevData) => ({ ...prevData, [name]: value }));
        validateField(name, value);
        if (name === 'state') {
          getCities(value);
        }
      }
      const handleChangeBusiness = (e) => {
        const { name, value } = e.target;
        setFormDataBusiness((prevData) => ({ ...prevData, [name]: value }));
        validateField(name, value);
      }
      
      const setTab = (tab) => {
        setActiveTab(tab);
      };
      const back = () => {
        navigate(-1); 
      }

    useEffect(() => {
        fetchData();
        document.body.style.backgroundColor = '#f0f6fa';
        return () => {
          document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
        };
}, []);
return(
    <div>
    <LoaderOverlay loading={loading} />
    <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
    <h4 style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Edit Distributor</h4>
    <div className="container-fluid ghty" style={{backgroundColor: 'white'}}>
    
        <ul className="nav nav-tabs">
          <li className="nav-item tbbtrn" onClick={() => setTab('per_details')} >
            <a className={`nav-link ${activeTab === 'per_details' ? 'active_tab1' : 'inactive_tab1'}`}  id="list_per_details" style={{cursor:'pointer'}}>Personal Information</a>
          </li>
          <li className="nav-item tbbtrn" onClick={() => setTab('address_details')} >
            <a className={`nav-link ${activeTab === 'address_details' ? 'active_tab1' : 'inactive_tab1'}`}  id="list_address_details" style={{cursor:'pointer'}}>Address</a>
          </li>
          <li className="nav-item tbbtrn" onClick={() => setTab('business_details')}>
            <a className={`nav-link ${activeTab === 'business_details' ? 'active_tab1' : 'inactive_tab1'}`}  id="list_business_details" style={{cursor:'pointer'}}>Business Information</a>
          </li>
          <li className="nav-item tbbtrn" onClick={() => setTab('admin_details')} >
            <a className={`nav-link ${activeTab === 'admin_details' ? 'active_tab1' : 'inactive_tab1'}`}  id="list_admin_details" style={{cursor:'pointer'}}>Admin Credentials</a>
          </li>
        </ul>
        <div  style={{marginTop: '16px'}}>
            <form onSubmit={updatePersonal} className="tab-content">
          <div  className={`tab-pane ${activeTab === 'per_details' ? 'active' : 'fade'}`} id="per_details">
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="container col-md-12" style={{padding: 0}}>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                       <FormField
                           type="text"
                           isRequierd = {true}
                           id="f_name"
                           name="fullName"
                           label="FULL NAME"
                           placeholder = "Enter Full Name"
                           value={formData.fullName}
                           onChange={handleChange}
                           error={errors.fullName}
                           maxlength = {20}
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                     
                      <FormField
                           type="text"
                           isRequierd = {true}
                           id="phone"
                           name="phoneNumber"
                           label="PHONE NUMBER"
                           placeholder = "Enter Phone Number"
                           value={formData.phoneNumber}
                           onChange={handleChange}
                           error={errors.phoneNumber}
                           maxlength = {10}
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                          
                          <SelectField 
                            id="comm_grp_id"
                            isRequierd = {true}
                            name="comm_grp_id"
                            label="COMMISSION GROUP"
                            selectedField = "Select Commssion Group"
                            value={formData.comm_grp_id}
                            onChange={handleChange}
                            error={errors.comm_grp_id}
                            options={commGroup}
                            />
                      
                      <span id="error_profiles_gender" className="text-danger" />
                    </div>
                    {/* <div className="form-group frm" style={{textAlign: 'left'}}>
                      
                     <SelectField 
                       id="limit_group"
                       isRequierd = {true}
                       name="limit_group"
                       label="LIMIT GROUP"
                       selectedField = "Select Limit Group"
                       value={formData.limit_group}
                       onChange={handleChange}
                       error={errors.limit_group}
                       options={limitGroups}
                    />
                    </div> */}
                  </div>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                       <FormField
                           type="email"
                           isRequierd = {true}
                           id="email"
                           name="email"
                           label="E-mail"
                           placeholder = "Enter Email"
                           value={formData.email}
                           onChange={handleChange}
                           error={errors.email}
                           disabled={true}
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <SelectField 
                       id="transaction_type"
                       isRequierd = {true}
                       name="transaction_type"
                       label="BUSINESS TYPE"
                       selectedField = "Select Business Type"
                       value={formData.transaction_type}
                       onChange={handleChange}
                       error={errors.transaction_type}
                       options={businessTypes}
                    />
                    </div>
                    
                  </div>
                </div>
                <br />
                <div align="left">
                <button type="button" name="btn_login_details" id="btn_login_details" className="btn backbt" style={{marginTop:'6px'}} onClick={back}>Back</button>
                  <button type="submit" name="btn_login_details" id="btn_login_details" className="btn ddfg" style={{marginLeft:'10px'}}>Update</button>
                </div>
                <br />
              </div>
            </div>
          </div>
          </form >
          <form className="tab-content" onSubmit={updateAddress}>
          <div className={`tab-pane ${activeTab === 'address_details' ? 'active' : 'fade'}`} id="address_details">
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="container col-md-12" style={{padding: 0}}>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      {/* <label className="required" htmlFor="f_name">ADDRESS LINE 1</label>
                      <input type="text" className="form-control" id="address_1" placeholder="Enter Address" name="address_1" />
                      <span id="error_address_1" className="text-danger" /> */}
                      <FormField
                           type="text"
                           isRequierd = {true}
                           id="addressLine1"
                           name="addressLine1"
                           label="ADDRESS LINE 1"
                           placeholder = "Enter Address"
                           value={formDataPersonal.addressLine1}
                           onChange={handleChangeAddress}
                           error={errors.addressLine1}
                           maxlength = {50}
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <SelectField 
                       id="state"
                       isRequierd = {true}
                       name="state"
                       label="STATE"
                       selectedField = "Select State"
                       value={formDataPersonal.state}
                       onChange={handleChangeAddress}
                       error={errors.state}
                       options={statesData}
                    />
                    
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                           type="text"
                           isRequierd = {true}
                           id="postalCode"
                           name="postalCode"
                           label="POSTAL CODE"
                           placeholder = "Enter Postal Code"
                           value={formDataPersonal.postalCode}
                           onChange={handleChangeAddress}
                           error={errors.postalCode}
                           maxlength = {6}
                        />
                      
                    </div>
                   
                  </div>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                           type="text"
                           isRequierd = {false}
                           id="addressLine2"
                           name="addressLine2"
                           label="ADDRESS LINE 2"
                           placeholder = "Enter Address"
                           value={formDataPersonal.addressLine2}
                           onChange={handleChangeAddress}
                           error={errors.addressLine2}
                           maxlength = {50}
                        />
                      
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      
                       <SelectField 
                       id="city"
                       isRequierd = {true}
                       name="city"
                       label="CITY"
                       selectedField = "Select City"
                       value={formDataPersonal.city}
                       onChange={handleChangeAddress}
                       error={errors.city}
                       options={city}
                    />
                      
                    </div>
                
                  </div>
                </div>
                <br />
                <div align="left">
                <button type="button" name="btn_login_details" id="btn_login_details" className="btn backbt" style={{marginTop:'6px'}} onClick={back}>Back</button>
                  <button type="submit" name="btn_login_details" id="btn_login_details" className="btn ddfg" style={{marginLeft:'10px'}}>Update</button>
                </div>
                <br />
              </div>
            </div>
          </div>
          </form>
          <form className="tab-content" onSubmit={updateBusiness}>
          <div className={`tab-pane ${activeTab === 'business_details' ? 'active' : 'fade'}`}  id="business_details">
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="container col-md-12" style={{padding: 0}}>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    

                      <FormField
                           type="text"
                           isRequierd = {false}
                           id="registrationNumber"
                           name="registrationNumber"
                           label="BUSINESS REGISTRATION NUMBER"
                           placeholder = "Enter Business Registration Number"
                           value={formDataBusiness.registrationNumber}
                           onChange={handleChangeBusiness}
                           error={errors.registrationNumber}
                           maxlength = {20}
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="Industry">INDUSTRY TYPE</label>
                     
                      <SelectField 
                       id="industry"
                       isRequierd = {false}
                       name="industry"
                       label="INDUSTRY TYPE"
                       selectedField = "Select Industry Type"
                       value={formDataBusiness.industry}
                       onChange={handleChangeBusiness}
                       error={errors.industry}
                       options={industryTypes}
                    />
                    </div>
                  </div>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                     

                      <FormField
                           type="text"
                           isRequierd = {false}
                           id="description"
                           name="description"
                           label="DESCRIPTION"
                           placeholder = "Enter DESCRIPTION"
                           value={formDataBusiness.description}
                           onChange={handleChangeBusiness}
                           error={errors.description}
                           maxlength = {50}
                        />
                    </div>
                  </div>
                </div>
                <br />
                
                <div align="left">
                
                <button type="button" name="btn_login_details" id="btn_login_details" className="btn backbt" style={{marginTop:'6px'}} onClick={back}>Back</button>
                  <button type="submit" name="btn_login_details" id="btn_login_details" className="btn ddfg" style={{marginLeft:'10px'}}>Update</button>
                </div>
                <br />
              </div>
            </div>
          </div>
          </form>
          <form className="tab-content" onSubmit={updateAdmin}>
          <div className={`tab-pane ${activeTab === 'admin_details' ? 'active' : 'fade'}`}  id="admin_details">
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="container col-md-12" style={{padding: 0}}>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <SelectField 
                       id="admin"
                       isRequierd = {false}
                       name="admin"
                       label="Admin Users"
                       selectedField = "Select Admin User"
                       value={formDataUsers.user}
                       onChange={handleChangeUser}
                       error={errors.user}
                       options={users}
                    />
                    </div>

                  </div>
                </div>
                <br />
                <div align="left">
                 
                <button type="button" name="btn_login_details" id="btn_login_details" className="btn backbt" style={{marginTop:'6px'}} onClick={back}>Back</button>
                  <button type="submit" name="btn_login_details" id="btn_login_details" className="btn ddfg" style={{marginLeft:'10px'}}>Update</button>
                </div>
                <br />
              </div>
            </div>
          </div>
          </form>
        </div>

    </div>
  </div>
  </div>
)


}

   
function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
  export default withAuth(connect(mapStateToProps)(EditDistributor));